// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__9VFp7","overflowing":"ReadFullNote_overflowing__1JZBi"};